export enum StorageKey {
  AuthenticationSession = "pantrystack.authenticationSession",
}
